// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HomePage_wrapper__3UziY","content":"HomePage_content__1v2M0","tablet":"HomePage_tablet__2kT2M","termsUser":"HomePage_termsUser__1PtIS"};